// @ts-strict-ignore
/** @jsx jsx */
/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-noninteractive-element-interactions, camelcase */

import * as React from 'react'
import { jsx } from 'theme-ui'
import { useInView } from 'react-intersection-observer'
import { timeout, useComponentTracking } from '@uswitch/ev-utils/component-events'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  link?: string
  children?: React.ReactNode
  onRowClick?: () => void
  disabled?: boolean
}

const linkWrapper = (
  trackComponent: (eventType: string, eventName: string, eventData: object) => void,
  brand: string,
  data: any,
  index: number,
  link: string,
  children: React.ReactNode,
  ref: any,
) => {
  const onClick = (e) => {
    e.preventDefault()
    e.stopPropagation()

    timeout(
      trackComponent('Product Table Event', 'rowClick', {
        brand,
        index,
        product_id: data?._source?.definition?.id,
        product_name: data?._source?.definition?.display_name,
      }),
    ).then(() => {
      window.open(link, '_blank').focus()
    })
  }
  return (
    <a
      data-product-table-action='primary-cta'
      ref={ref}
      sx={{
        textDecoration: 'none',
        ':hover:not(:disabled)': {
          'a:not(.secondary-link), button:not(.secondary-link)': {
            background: '#db4d75',
          },
          header: {
            h5: {
              textDecoration: 'underline',
              textDecorationColor: '#069',
            },
          },
        },
      }}
      href={link}
      target='_blank'
      rel='noopener noreferrer'
      onClick={onClick}
    >
      {children}
    </a>
  )
}

const RowWrapper: React.FC<Props> = ({
  brand,
  data,
  link,
  children,
  onRowClick,
  disabled,
  index,
}) => {
  const trackComponent = useComponentTracking()
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.5 })

  React.useEffect(() => {
    if (inView) {
      trackComponent('Product Table Event', 'viewed', {
        brand,
        product_id: data?._source?.definition?.id,
        product_name: data?._source?.definition?.display_name,
        index,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView])

  if (disabled) {
    return <div ref={ref}>{children}</div>
  }
  if (onRowClick) {
    return (
      <div ref={ref} sx={{ cursor: 'pointer' }} onClick={onRowClick} role='button' tabIndex={0}>
        {children}
      </div>
    )
  }
  if (link) {
    return linkWrapper(trackComponent, brand, data, index, link, children, ref)
  }

  return <div ref={ref}>{children}</div>
}

export default RowWrapper
